export enum WorkstateEnum {
  UNDEFINED = 'UNDEFINED',

  /**************/
  /* FELDARBEIT */
  /**************/
  PREPARATION = 'PREPARATION',
  ROAD = 'ROAD',
  MISC_ROAD = 'MISC_ROAD',
  WORKING = 'WORKING',
  TURNING = 'TURNING',
  MISC_FIELD = 'MISC_FIELD',

  /*************/
  /* TRANSPORT */
  /*************/
  // PREPARATION = 'PREPARATION',
  TRANSPORT_UNLOADED = 'TRANSPORT_UNLOADED',
  TRANSPORT_LOADED = 'TRANSPORT_LOADED',
  TRANSPORT_LOADING = 'TRANSPORT_LOADING',
  TRANSPORT_UNLOADING = 'TRANSPORT_UNLOADING',
  // MISC_ROAD = 'MISC_ROAD',
  // MISC_FIELD = 'MISC_FIELD',

  /**************/
  /* KOMBINIERT */
  /**************/
  // PREPARATION = 'PREPARATION',
  // ROAD = 'ROAD',
  // MISC_ROAD = 'MISC_ROAD',
  // WORKING = 'WORKING',
  // TURNING = 'TURNING',
  // TRANSPORT_LOADING = 'TRANSPORT_LOADING',
  // TRANSPORT_UNLOADING = 'TRANSPORT_UNLOADING',
  // MISC_FIELD = 'MISC_FIELD',

  /****************/
  /* MAEHDRESCHER */
  /****************/
  // PREPARATION = 'PREPARATION',
  // ROAD = 'ROAD',
  // MISC_ROAD = 'MISC_ROAD',
  THRESHING = 'THRESHING',
  THRESHING_WITH_STRAWCHOPPER = 'THRESHING_W_SC',
  THRESHING_UNLOADING = 'THRESHING_U',
  THRESHING_WITH_STRAWCHOPPER_UNLOADING = 'THRESHING_W_SC_U',
  // TRANSPORT_UNLOADING = 'TRANSPORT_UNLOADING',
  TRANSPORT_UNLOADING_DRIVING = 'TRANSPORT_UNLOADING_DRIV',
  // MISC_FIELD = 'MISC_FIELD',
  MISC_FIELD_GRAINTANK_FULL = 'MISC_FIELD_GTF',

  /*************/
  /* LEERFAHRT */
  /*************/
  DRIVING = 'DRIVING',
  DRIVING_MISC = 'DRIVING_MISC',
}
